var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"g-ft"},[_c('div',{staticClass:"m-name"},[_vm._v("\n    粤ICP备13027716号 版权所有：广州昊达信息科技有限公司 联系电话：400-138-6626 "),_c('br'),_vm._v("\n    公司地址：广州大道中富力新天地中心4206室\n  ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-78b6004b","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/footbar/index.vue
// module id = null
// module chunks = 